import React from 'react';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  /** Required for screen readers. */
  'aria-label': string;
  variant?: 'ghost' | 'filled' | 'active' | 'danger';
  size?: 'sm' | 'md';
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  variant = 'ghost',
  size = 'md',
  className,
  ...rest
}) => (
  <button
    type="button"
    className={[
      'rr-iconbtn',
      variant !== 'ghost' ? `rr-iconbtn-${variant}` : '',
      size === 'sm' ? 'rr-iconbtn-sm' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    {...rest}
  >
    {icon}
  </button>
);

export default IconButton;
